/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ features: NonNullable<unknown>, date: NonNullable<unknown> }} Cancel_Confirm_BodyInputs */

const en_cancel_confirm_body = /** @type {(inputs: Cancel_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You'll lose access to ${i?.features} at the end of your billing period on ${i?.date}.`)
};

const de_cancel_confirm_body = /** @type {(inputs: Cancel_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du verlierst den Zugang zu ${i?.features} am Ende deines Abrechnungszeitraums am ${i?.date}.`)
};

const fr_cancel_confirm_body = /** @type {(inputs: Cancel_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu perdras l'acces a ${i?.features} a la fin de ta période de facturation le ${i?.date}.`)
};

const es_cancel_confirm_body = /** @type {(inputs: Cancel_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perderas acceso a ${i?.features} al final de tu periodo de facturacion el ${i?.date}.`)
};

const it_cancel_confirm_body = /** @type {(inputs: Cancel_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perderai l'accesso a ${i?.features} alla fine del periodo di fatturazione il ${i?.date}.`)
};

const nl_cancel_confirm_body = /** @type {(inputs: Cancel_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je verliest toegang tot ${i?.features} aan het einde van je factureringsperiode op ${i?.date}.`)
};

const pl_cancel_confirm_body = /** @type {(inputs: Cancel_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stracisz dostep do ${i?.features} na koniec okresu rozliczeniowego ${i?.date}.`)
};

const fi_cancel_confirm_body = /** @type {(inputs: Cancel_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Menetat paasyn kohteeseen ${i?.features} laskutusjakson lopussa ${i?.date}.`)
};

const da_cancel_confirm_body = /** @type {(inputs: Cancel_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du mister adgang til ${i?.features} ved slutningen af din faktureringsperiode den ${i?.date}.`)
};

const sv_cancel_confirm_body = /** @type {(inputs: Cancel_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du förlorar tillgång till ${i?.features} i slutet av din faktureringsperiod den ${i?.date}.`)
};

/**
* | output |
* | --- |
* | "You'll lose access to {features} at the end of your billing period on {date}." |
*
* @param {Cancel_Confirm_BodyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_confirm_body = /** @type {((inputs: Cancel_Confirm_BodyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Confirm_BodyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_confirm_body(inputs)
	if (locale === "fr") return fr_cancel_confirm_body(inputs)
	if (locale === "es") return es_cancel_confirm_body(inputs)
	if (locale === "it") return it_cancel_confirm_body(inputs)
	if (locale === "nl") return nl_cancel_confirm_body(inputs)
	if (locale === "pl") return pl_cancel_confirm_body(inputs)
	if (locale === "fi") return fi_cancel_confirm_body(inputs)
	if (locale === "da") return da_cancel_confirm_body(inputs)
	if (locale === "sv") return sv_cancel_confirm_body(inputs)
	return en_cancel_confirm_body(inputs)
});